var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 40,
    viewBox: "0 0 81 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00101471 20.102L39.2878 39.7349V27.0015C37.7378 27.0015 36.3311 27.5611 35.2335 28.479C33.9791 29.5356 32.2409 29.7953 30.7805 29.0521L13.152 20.1065L30.7805 11.1609C32.2454 10.4176 33.9791 10.6773 35.2335 11.734C36.3311 12.6563 37.7423 13.2115 39.2878 13.2115L39.2878 0.460178L-0.00101471 20.0975V20.102Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2944 0.260559L41.2944 12.9939C42.8444 12.9939 44.2511 12.4388 45.3487 11.5164C46.6031 10.4598 48.3413 10.2001 49.8018 10.9433L67.4302 19.8889L49.7973 28.8345C48.3323 29.5778 46.5986 29.3181 45.3442 28.2615C44.2467 27.3391 42.8355 26.784 41.2899 26.784V39.5308L80.5833 19.8934L41.2944 0.260559Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.f67245d525cec9161b99e0666ce7011b.svg";
export { ForwardRef as ReactComponent };